import { createStore } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import type { StoreActions, StoreState } from "./types";

const defaultState: StoreState = {
	shareClasses: [],
	activeShareClass: null,
	breadcrumbs: null,
	structure: null,
	components: {},
	hiddenSections: [],
	citywireImages: {},
	audienceSelectData: { enabled: false },
	fundId: 0,
	audienceId: 0,
	isOpenSidebar: false,
};

const storeCreator = (initialState?: Partial<StoreState>) =>
	createStore<StoreState & StoreActions>()(
		devtools(
			immer((set, get) => ({
				...{ ...defaultState, ...initialState },
				doSetActiveShareClass(id) {
					set(
						(state) => {
							state.activeShareClass =
								state.shareClasses.find((sc) => sc.id === id) || null;
						},
						false,
						{
							type: `doSetActiveShareClass: ${id}`,
							payload: { id },
						},
					);
				},
				doSetShareClasses(shareClasses) {
					set({ shareClasses }, false, {
						type: `doSetShareClasses: ${shareClasses.length}`,
						payload: { shareClasses },
					});
				},
				doSetBreadcrumbs(breadcrumbs) {
					set({ breadcrumbs }, false, {
						type: `doSetBreadcrumbs: ${breadcrumbs.length}`,
						payload: { breadcrumbs },
					});
				},
				doSetPageStructure(structure) {
					set({ structure }, false, {
						type: `doSetPageStructure: ${structure.name}`,
						payload: { structure },
					});
				},
				doGetComponent(name) {
					return get().components[name];
				},
				doToggleSection(sectionId, hide) {
					set(
						(state) => {
							if (!hide) {
								state.hiddenSections = state.hiddenSections.filter(
									(s) => s !== sectionId,
								);
							} else {
								if (!state.hiddenSections.includes(sectionId)) {
									state.hiddenSections.push(sectionId);
								}
							}
						},
						false,
						{
							type: `doToggleSection: ${sectionId}`,
							payload: { sectionId },
						},
					);
				},
				doToggleSidebar(isOpenSidebar) {
					set({ isOpenSidebar }, false, {
						type: `doToggleSidebar: ${isOpenSidebar}`,
						payload: { isOpenSidebar },
					});
				},
			})),
			{
				name: "RLAM Fund Page",
				enabled: process.env.NODE_ENV !== "production",
				store: `RLAM FP-${(Math.random() * 100).toFixed(0)}`,
			},
		),
	);

export type FundPageStore = ReturnType<typeof storeCreator>;
export default storeCreator;
